import * as React from 'react';
import { AccordionItemHeading, AccordionItemButton, AccordionItemState, AccordionItemPanel } from 'react-accessible-accordion';
import classNames from 'classnames';
import CaretDownSolid from '../../../icons/CaretDownSolid.esm.js';
import CaretRightSolid from '../../../icons/CaretRightSolid.esm.js';
import { NvMarkdownInline, NvMarkdown } from '@invitae/ids-react';
import styles from '../AccordionSection.module.esm.js';
import styles$1 from './AccordionSectionItem.module.esm.js';

var AccordionSectionItem = function (_a) {
    var id = _a.id, _b = _a.fields, heading = _b.heading, body = _b.body, onHeaderClick = _b.onHeaderClick;
    var accordionButtonStyle = classNames(styles.accordionButton, styles$1.accordionButton);
    return (React.createElement("div", { id: id },
        React.createElement(AccordionItemHeading, { className: styles$1.accordionHeading, onClick: function (e) { return onHeaderClick(e, id); } },
            React.createElement(AccordionItemButton, { className: accordionButtonStyle },
                React.createElement(AccordionItemState, null, function (_a) {
                    var expanded = _a.expanded;
                    return (React.createElement("div", { className: styles$1.caretAndHeadingWrapper },
                        expanded ? (React.createElement("span", { className: styles$1.iconWrapper },
                            React.createElement(CaretDownSolid, null))) : (React.createElement("span", { className: styles$1.iconWrapper },
                            React.createElement(CaretRightSolid, null))),
                        React.createElement(NvMarkdownInline, { elementWrapper: "span" }, heading)));
                }))),
        React.createElement(AccordionItemPanel, { className: styles$1.accordionPanel },
            React.createElement(NvMarkdown, null, body))));
};

export { AccordionSectionItem as default };
//# sourceMappingURL=AccordionSectionItem.esm.js.map
